import { Link } from '@inertiajs/inertia-vue3'
import PageComponent from '@/pages/page-component'
import FormComponent from '@/pages/form-component'
import DataTable from '@/components/data-table.vue'
import { Inertia } from '@inertiajs/inertia'

export default {
  mixins: [
    PageComponent,
    FormComponent,
  ],

  components: {
    DataTable,
    Link,
  },

  props: {
    search: String,
    errors: Object,
    selectedOptions: Object,
  },

  data() {
    return {
      title: `Builds :: Add Build`,
      form: {
        search: this.search,
        ...this.getSelectedOptions(),
      },
    }
  },

  methods: {
    submit() {
      Inertia.get(this.$route('builds.create'), this.form)
    },

    getSelectedOptions() {
      return this.selectedOptions
    }
  }
}
